import React from 'react';
import { ReptoolModal } from './ReptoolModal.tsx';

export const MissionStatementModal = ({ closeModal }: {
  closeModal: () => void,
}) => {

  return (
    <ReptoolModal title="RepTool's Mission" closeModal={() => closeModal()} body={
      <div className='text-light'>
        <h4>Our Mission</h4>
        <p>
          At RepTool, my mission is to provide reptile keepers and breeders with the most reliable, innovative, and user-friendly tools for husbandry, all while allowing you to decide what’s fair when it comes to pricing. As a dedicated reptile keeper and breeder myself, this app is a passion project built with the community in mind. Every feature and piece of content within RepTool is designed to support you on your journey, and the information supplied is entirely community-driven. I take great pride in ensuring that all content is shared with the permission of its original owners, fostering an environment of respect, collaboration, and trust. My goal is to create a platform where reptile care thrives, and together, we can contribute to the well-being of reptiles everywhere.
        </p>
        <h4 className='mt-4'>How you can help!</h4>
        <p>
          I’d love your help in making the app even better. You can contribute by sharing pictures to help identify and showcase reptile morphs, submitting any reptiles or genetics that may be missing, and creating a subscription if you find value in what RepTool offers. If you’re enjoying the app, leaving a positive review on the App Store would mean the world to me! Every contribution helps RepTool grow and improve, and I truly appreciate your support in building a better tool for the reptile community.
        </p>
      </div>

    } />
  )
}